import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import ActionBar from "../../common/ActionBar";
import { OuterContainer } from "../../EventCreation/styles";
import { Formik } from "formik";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import { navigate } from "@reach/router";
import { userAccessValidationSchema } from "../../../helpers/validationSchema";
import _ from "lodash";

const UserAccessRegistration = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [info, setInfo] = useState();
  const [clickedButton, setClickedButton] = useState("");

  const input_one = [
    {
      name: "enableRegistration",
      label: "Enable Registration",
      type: "switch",
    },
    {
      name: "commonPassword",
      label: "Common Password",
      type: "switch",
    },
    {
      name: "enableLogins",
      label: "Enable Logins",
      type: "switch",
    },
    {
      name: "ipListRestrictions",
      label: "IP List Restrictions",
      type: "switch",
    },
    {
      name: "passwordRequired",
      label: "Password Required",
      type: "switch",
    },
    {
      name: "singleUserSingleEntry",
      label: "Single User Single Entry",
      type: "switch",
    },
    {
      name: "sendEmailDuringRegistration",
      label: "Send Email During Registration",
      type: "switch",
    },
    {
      name: "labelsOutside",
      label: "Labels Outside",
      type: "switch",
    },
    {
      name: "userViewInsidePage",
      label: "User Allowed to View Inside Pages",
      type: "switch",
    },
    {
      name: "commonPasswordEntry",
      label: "Common Password Entry",
      type: "text",
      placeholder: "Enter common password entry",
    },
  ];

  const pre_validate_users = [
    {
      name: "preValidateRegistration",
      label: "Pre-validate Registration",
      type: "switch",
    },
    {
      name: "preValidateLabel",
      label: "Pre Validate Label",
      type: "select",
      menuItems: [
        { label: "Email Address", value: "emailId" },
        { label: "Mobile Number", value: "mobile" },
        { label: "Employee id", value: "employeeId" },
      ],
    },
  ];

  const pre_validate_users_list = [
    {
      name: "preValidateUserList",
      label: "Prevalidate User List",
      type: "uploads",
      accept: ".xlsx",
    },
  ];

  const remainders = [
    {
      name: "sms",
      label: "SMS",
      type: "switch",
    },
    {
      name: "email",
      label: "Email",
      type: "switch",
    },
    {
      name: "whatsApp",
      label: "WhatsApp",
      type: "switch",
    },
    {
      name: "voiceDrop",
      label: "Voice Drop",
      type: "switch",
    },
    {
      name: "individual",
      label: "Personal Invitation",
      type: "switch",
    },
  ];

  const radioOptions = [
    { label: "Before Login", name: "beforeLogin", value: "beforeLogin" },
    { label: "After Login", name: "afterLogin", value: "afterLogin" },
    {
      label: "Both Before & After",
      name: "bothBeforeAfter",
      value: "bothBeforeAfter",
    },
  ];

  const speakers_section = [
    {
      name: "speakersRequired",
      label: "Speakers Required",
      type: "switch",
    },
    {
      name: "speakersVisibility",
      label: "Speakers Visibility",
      type: "radio",
      menuItems: radioOptions,
    },
  ];

  const resources_section = [
    {
      name: "resourcesRequired",
      label: "Resources Required",
      type: "switch",
    },
    {
      name: "resourcesVisibility",
      label: "Resources Visibility",
      type: "radio",
      menuItems: radioOptions,
    },
  ];

  const force_referrer = [
    {
      name: "forceReferrerCheck",
      label: "Force Referrer Check",
      type: "switch",
    },
    {
      name: "referrerCheckUrl",
      label: "Resources Visibility",
      type: "text",
      placeholder: "Enter referrer check url",
    },
  ];

  const buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      disabled: id?.id ? false : true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      disabled: id?.id ? false : true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "event");
        setInfo(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } else {
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "event");
      setInfo(response);
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description user access registration function
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        ...values,
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(
          `/dashboard/eventmanager/form-settings/custom-filed-addition/${id?.id}`,
        );
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /*

  const handleChangeInfo = (event, item, values, setFieldValue) => {
    if (item.name === "enableRegistration") {
      setFieldValue(`eventSettings.enableRegistration`, true);
      setFieldValue(`eventSettings.enableLogins`, true);
    } else {
      setFieldValue(`eventSettings.${item.name}`, event.target.checked);
    }
    if (
      values?.eventSettings?.["enableLogins"] &&
      values?.eventSettings?.["enableRegistration"] &&
      item.name === "enableLogins"
    ) {
      setFieldValue(`eventSettings.enableRegistration`, false);
      setFieldValue(`eventSettings.enableLogins`, false);
    } else if (
      values?.eventSettings?.["enableLogins"] &&
      values?.eventSettings?.["enableRegistration"] &&
      item.name === "enableRegistration"
    ) {
      setFieldValue(`eventSettings.enableRegistration`, false);
      setFieldValue(`eventSettings.enableLogins`, true);
    }
  };

  */

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case id?.id ? "event_details" : "create_new_event":
        id?.id
          ? navigate(`/dashboard/eventmanager/event-details/${id?.id}`)
          : navigate(`/dashboard/eventmanager/event-details`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Event Details",
                "User access and registration",
                info?.eventName
                  ? `${info?.eventName} (${info?.eventDate})`
                  : "",
              ]
            : [
                "Event Manager",
                "Create New Event",
                "User access and registration",
              ]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            eventSettings: {
              eventTemplate: info?.eventTemplate,
              atLeastOneSelected: null,
              enableRegistration:
                info?.eventSettings?.enableRegistration || false,
              commonPassword: info?.eventSettings?.commonPassword || false,
              commonPasswordEntry:
                info?.eventSettings?.commonPasswordEntry || "",
              enableLogins: info?.eventSettings?.enableLogins || false,
              ipListRestrictions:
                info?.eventSettings?.ipListRestrictions || false,
              passwordRequired: info?.eventSettings?.passwordRequired || false,
              singleUserSingleEntry:
                info?.eventSettings?.singleUserSingleEntry || false,
              sendEmailDuringRegistration:
                info?.eventSettings?.sendEmailDuringRegistration || false,
              labelsOutside:
                info?.eventSettings?.labelsOutside === false ? false : true,
              userViewInsidePage:
                info?.eventSettings?.userViewInsidePage || false,
            },
            preValidateUsers: {
              preValidateRegistration:
                info?.preValidateUsers?.preValidateRegistration || false,
              preValidateLabel:
                info?.preValidateUsers?.preValidateLabel || "emailId",
            },
            preValidateUserList: info?.preValidateUserList || [],
            speakerSection: {
              speakersRequired: info?.speakerSection?.speakersRequired || false,
              speakersVisibility:
                info?.speakerSection?.speakersVisibility || "bothBeforeAfter",
            },
            forceReferrer: {
              forceReferrerCheck:
                info?.forceReferrer?.forceReferrerCheck || false,
              referrerCheckUrl: info?.forceReferrer?.referrerCheckUrl || "",
            },
            reminders: {
              sms: info?.reminders?.sms === false ? false : true,
              email: info?.reminders?.email || "",
              whatsApp: info?.reminders?.whatsApp || "",
              voiceDrop: info?.reminders?.voiceDrop || "",
              individual: info?.reminders?.individual || "",
            },
            resourceSection: {
              resourcesRequired:
                info?.resourceSection?.resourcesRequired || false,
              resourcesVisibility:
                info?.resourceSection?.resourcesVisibility || "bothBeforeAfter",
            },
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={userAccessValidationSchema}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            handleChange,
            resetForm,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>User access and registration</Heading>
                  <Grid container spacing={3} style={{ padding: 16 }}>
                    <Grid item xs={12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Event Settings</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {input_one.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={6}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                }}
                                width={"210px"}
                                error={errors?.eventSettings?.[item.name]}
                                helperText={errors?.eventSettings?.[item.name]}
                                value={values?.eventSettings?.[item.name]}
                                name={`eventSettings.${item.name}`}
                                touched={`eventSettings.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                        <div style={{ marginBottom: "20px" }}>
                          {errors?.eventSettings?.atLeastOneSelected
                            ?.length && (
                            <HelperText>
                              {errors?.eventSettings?.atLeastOneSelected}
                            </HelperText>
                          )}
                        </div>
                      </Paper>
                    </Grid>
                    <Grid item xs={12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Pre-validate users</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {pre_validate_users.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                  setFieldValue,
                                }}
                                error={errors?.preValidateUsers?.[item.name]}
                                helperText={
                                  errors?.preValidateUsers?.[item.name]
                                }
                                accept={item.accept}
                                menuItems={item.menuItems}
                                direction={"row"}
                                width={"210px"}
                                value={values?.preValidateUsers?.[item.name]}
                                name={`preValidateUsers.${item.name}`}
                                touched={`preValidateUsers.${item.name}`}
                              />
                            </Grid>
                          ))}
                          {pre_validate_users_list.map((item, index) => (
                            <Grid
                              item
                              xs={isBigScreen ? 4 : 12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                  setFieldValue,
                                }}
                                error={errors[item.name]}
                                helperText={errors[item.name]}
                                accept={item.accept}
                                direction={"row"}
                                width={"210px"}
                                value={values[item.name]}
                                name={item.name}
                                touched={touched[item.name]}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={isBigScreen ? 12 : 12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Reminders</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {remainders.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={6}
                              lg={4}
                              xl={2}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                  setFieldValue,
                                }}
                                width={"210px"}
                                value={values?.reminders?.[item.name]}
                                name={`reminders.${item.name}`}
                                touched={`reminders.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={isBigScreen ? 12 : 12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Speakers Section</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {speakers_section.map((item, index) => (
                            <Grid
                              item
                              xs={isBigScreen ? 6 : 12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                }}
                                direction={"row"}
                                width={"210px"}
                                value={values.speakerSection[item.name]}
                                name={`speakerSection.${item.name}`}
                                touched={`speakerSection.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>

                    <Grid item xs={isBigScreen ? 6 : 12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Resources Section</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {resources_section.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                }}
                                direction={"row"}
                                width={"210px"}
                                value={values?.resourceSection?.[item.name]}
                                name={`resourceSection.${item.name}`}
                                touched={`resourceSection.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={isBigScreen ? 6 : 12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Force Referrer</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {force_referrer.map((item, index) => (
                            <Grid
                              item
                              xs={12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  values,
                                  errors,
                                }}
                                error={errors?.forceReferrer?.[item.name]}
                                helperText={errors?.forceReferrer?.[item.name]}
                                direction={"row"}
                                width={"210px"}
                                value={values.forceReferrer[item.name]}
                                name={`forceReferrer.${item.name}`}
                                touched={`forceReferrer.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <FormControl>
                      <ButtonContainer>
                        {buttons.map((button) => (
                          <PrimaryCTAButton
                            style={{ width: "auto", marginLeft: 8 }}
                            onClick={() =>
                              handleButtonClick(button, resetForm, handleSubmit)
                            }
                          >
                            {button.label}
                          </PrimaryCTAButton>
                        ))}
                      </ButtonContainer>
                    </FormControl>
                  </Grid>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default UserAccessRegistration;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 90%;
  }
`;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const HelperText = styled.div`
  position: absolute;
  font-size: 10px;
  font-family: openSans-SemiBold, sans-serif;
  color: #f44336;
`;
